import { alpha, lighten } from "@mui/system";

const styles = (theme) => ({
  containerComponent: {
    width: "100%",

    p: 2,
  },
  boxContainer: {
    borderRadius: "16px",
    p: 3,
    mb: 2,
    textAlign: "center",
    transition: "background-color 0.2s, border-color 0.2s",
    height: "600px",
    overflowY: "auto",
  },
  boxContainerIcon: {
    fontSize: "40px",
    color: theme.palette.text.disabled,
    mb: 0.5,
  },
  textInfoSecondary: {
    fontSize: "12px",
    color: theme.palette.text.disabled,
  },
  filesHeader: {
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    mt: 2,
    mb: 1,
    px: 0.5,
  },
  filesHeaderLabel: {
    fontSize: "12px",
    fontWeight: 600,
    color: theme.palette.text.secondary,
  },
  boxImagePreview: {
    position: "relative",
    borderRadius: "14px",
    border: `1px solid ${alpha(theme.palette.text.primary, 0.12)}`,
    backgroundColor: theme.palette.background.paper,
    overflow: "hidden",
    textAlign: "center",
    height: 140,
  },
  avatar: {
    width: "100%",
    height: "100%",
    objectFit: "cover",
    borderRadius: 0,
  },
  imageCaptionOverlay: {
    position: "absolute",
    left: 0,
    right: 0,
    bottom: 0,
    p: "6px 8px",
    textAlign: "left",
    background: `linear-gradient(0deg, ${alpha(
      theme.palette.colors.black.darker,
      0.85,
    )} 0%, ${alpha(theme.palette.colors.black.darker, 0)} 100%)`,
  },
  imageCaptionText: {
    color: theme.palette.white.main,
    fontSize: "11px",
    fontWeight: 600,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
  },
  boxTitleAnexo: {
    maxWidth: "150px",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    p: 1,
  },
  boxTextAnexo: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    maxWidth: "90%",
    fontSize: "12px",
    fontWeight: 500,
  },
  fileSizeCaption: {
    fontSize: "10px",
    color: theme.palette.text.disabled,
  },
  fileIconBadge: {
    width: 44,
    height: 44,
    borderRadius: "12px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  containerCard: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    height: "100%",
    width: "100%",
    gap: 0.5,
    p: 1,
  },
  textFileName: {
    wordBreak: "break-all",
    height: 100,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  iconButton: {
    position: "absolute",
    top: 6,
    right: 6,
    zIndex: 2,
    width: 22,
    height: 22,
    backgroundColor: alpha(theme.palette.colors.black.darker, 0.55),
    backdropFilter: "blur(2px)",
    "&:hover": {
      backgroundColor: lighten(theme.palette.colors.black.darker, 0.15),
    },
  },
  textInfo: { mb: 1, fontSize: "14px" },
});

export default styles;
